import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const PanelLayout = styled.aside`
  grid-area: sidepanel;
  background: ${colors.white};
  height: 100%;
  width: 100%;
  overflow-y: auto;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 3rem auto 1fr auto;
  grid-template-areas:
    "nav"
    "header"
    "content"
    "commentinput";
`;
